import { CanActivateFn, Router } from '@angular/router';
import { inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

export const authGuardGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const platformId = inject(PLATFORM_ID);
  
  // const token = localStorage.getItem('token');
  // if (isPlatformBrowser(platformId)) {
  //   const token = localStorage.getItem('token');
  //   if (token) {
  //     return true;
  //   } else {
  //     router.navigate(['/login'], { queryParams: { redirectUrl: state.url } });
  //   return false;
  //   }
  // } else {
  //   router.navigate(['/login'], { queryParams: { redirectUrl: state.url } });
  //   return false;
  // }

// 1. SSR Check: Ensure we are in the browser to access localStorage
  if (isPlatformBrowser(platformId)) {
    const token = localStorage.getItem('token');
    const targetUrl = state.url;

    // 2. Public Route Exception: Always allow '/check'
    if (targetUrl.startsWith('/check')) {
      return true;
    }

    if (token) {
      // 3. Logged in & hitting Root: Redirect to Dashboard
      if (targetUrl === '/') {
        router.navigate(['/dashboard/home']);
        return false;
      }
      // 4. Logged in & hitting any other route: Stay there
      return true;
    } else {
      // 5. Not logged in: Redirect to Root (unless already there)
      if (targetUrl !== '/') {
        router.navigate(['/'], { queryParams: { returnUrl: targetUrl } });
        return false;
      }
      return true;
    }
  }

  // Default for SSR/Non-browser environments
  return true;
};